/* unplugin-vue-components disabled */import { render } from "./circularSpinner.vue?vue&type=template&id=2790a6a0&scoped=true"
const script = {}

import "./circularSpinner.vue?vue&type=style&index=0&id=2790a6a0&scoped=true&lang=css"

import exportComponent from "../../../../../unionglobal-store-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2790a6a0"]])

export default __exports__